import { z } from 'zod'

// Сотрудник stit (read-only): пикер ответственного/команды.
export const EmployeeSchema = z.object({
  id: z.string(),
  full_name: z.string(),
  email: z.string().optional(),
})
export type Employee = z.infer<typeof EmployeeSchema>

// Проект в разрезе сотрудника. Адрес карточки — `/{company_slug}/{slug}`,
// поэтому слаг компании едет рядом с самим проектом.
export const EmployeeProjectBriefSchema = z.object({
  id: z.string(),
  title: z.string(),
  slug: z.string(),
  company_id: z.string(),
  company_name: z.string(),
  company_slug: z.string(),
})
export type EmployeeProjectBrief = z.infer<typeof EmployeeProjectBriefSchema>

// Строка реестра «Сотрудники»: штатник и его нагрузка числами. Сами проекты
// приезжают карточкой сотрудника — реестр их не возит.
export const EmployeeWorkloadSchema = z.object({
  id: z.string(),
  full_name: z.string(),
  email: z.string().optional(),
  responsible_count: z.number().default(0),
  team_count: z.number().default(0),
})
export type EmployeeWorkload = z.infer<typeof EmployeeWorkloadSchema>

// Карточка сотрудника: он сам и его проекты по ролям. Бэк отдаёт оба разреза
// всегда (пустой — []), архивные проекты в них не идут. Проект, где сотрудник и
// ответственный, и в команде, лежит в обоих — это не дубль.
export const EmployeeProjectsSchema = z.object({
  id: z.string(),
  full_name: z.string(),
  email: z.string().optional(),
  responsible: z.array(EmployeeProjectBriefSchema).default([]),
  team: z.array(EmployeeProjectBriefSchema).default([]),
})
export type EmployeeProjects = z.infer<typeof EmployeeProjectsSchema>
